import React, { useState, useEffect } from 'react'

import { Card } from 'components'
import useLoading from 'hooks/useLoading'
import moment from 'moment'
import { LogEmailJobService } from 'services/NGT/Parameterization'
import { COLORS, SPACING, FORMAT } from 'utils'

import { FiltersJobs, TableJobs } from './components'
import { IFieldsFilterJobs } from './components/FiltersJobs/FiltersJobs'
import { useModal } from 'hooks'

// import { tableData } from "./mock"
// import { Container } from './styles';

const SearchJobs: React.FC = () => {
  const [tableData, setTableData] = useState([])
  const [page, setPage] = useState(1)
  const [totalItems, setTotalItems] = useState(0)
  const [pageSize, setPageSize] = useState(15)
  const [tipos, setTipos] = useState([])
  const [valueFilters, setValueFilters] = useState<IFieldsFilterJobs>()
  const [changeEffect, setChangeEffect] = useState<boolean>()
  const { setLoading } = useLoading()
  const { showModal } = useModal()

  const getTipos = () => {
    LogEmailJobService()
      .getTipos()
      .then(({ data }) => {
        setTipos(data)
      })
  }

  const getDataJobs = () => {
    setLoading('loading')
    let obj = {}

    if (valueFilters) {
      obj = valueFilters
    }

    obj['PageNumber'] = page
    obj['PageSize'] = pageSize

    LogEmailJobService()
      .getWithFilters(obj)
      .then((response) => {
        setTotalItems(response.data?.entity?.pageCount)
        setTableData(response.data?.entity?.items)
        setLoading('idle')
      })
      .catch(() => {
        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message: 'Erro ao obter os dados da pesquisa!',
          type: 'error'
        })
      })
  }

  const handleOnClearButtonClick = () => {
    setValueFilters(() => ({
      DtEnvioFim: null,
      DtEnvioInicio: null,
      NmFornecedor: '',
      NmTipoJOB: ''
    }))
    setChangeEffect((oldData) => !oldData)
  }

  const handleSubmitForm = (data: IFieldsFilterJobs) => {
    const { DtEnvioInicio, DtEnvioFim, ...rest } = data
    setValueFilters(() => ({
      ...FORMAT.dateIfExists({ DtEnvioFim, DtEnvioInicio }),
      ...rest
    }))
    setChangeEffect((oldData) => !oldData)
  }

  useEffect(() => {
    if (page === 1) {
      getDataJobs()
      return
    }
    setPage(1)
  }, [changeEffect])

  useEffect(() => {
    getDataJobs()
    getTipos()
  }, [])

  useEffect(() => {
    getDataJobs()
  }, [pageSize, page, valueFilters])

  return (
    <Card
      marginLeft={SPACING.spacing20}
      marginRight={SPACING.spacing20}
      marginBottom={SPACING.spacing100}
      padding={SPACING.spacing20}
      boxShadow={`0 0 1em ${COLORS.lightGray}`}
    >
      {tipos && (
        <FiltersJobs
          tipos={tipos}
          handleSubmitForm={handleSubmitForm}
          handleOnClickClearButton={handleOnClearButtonClick}
        />
      )}
      {tableData && (
        <TableJobs
          page={page}
          setPage={setPage}
          totalItems={totalItems}
          pageSize={pageSize}
          setPageSize={setPageSize}
          tableData={tableData}
        />
      )}
    </Card>
  )
}

export default SearchJobs
